<div class="dah-header-placeholder" [style.paddingTop.px]="(headerFixed() || navOpen()) ? headerHeight() : 0">
<header class="dah-header" [class.is-fixed]="headerFixed() || navOpen()" [class.is-sticky]="headerSticky()"
        [class.is-transition]="fixedTransition()" [class.is-logo-hidden]="logoHidden()"
        [class.is-nav-open]="navOpen()" [style.--dah-logobar-height]="logobarHeight() + 'px'">
  <div class="dah-header__logobar" #logobarEl>
    <a [href]="tenant.content.headerHref" class="dah-header__brand">
      <img class="dah-header__logo" [src]="tenant.content.logoPath" [alt]="tenant.content.organisationName">
    </a>
    <div class="dah-header__logobar-decoration"></div>
  </div>
  <div class="dah-header__metabar" #metabarEl>
    <div class="dah-container dah-header__metabar-inner">
      <button type="button" class="dah-header__burger" [class.is-open]="navOpen()"
              [attr.aria-expanded]="navOpen()" (click)="setNavOpen(!navOpen())" aria-label="Menü">
        <!-- Vendor-SVGs menu.svg/close.svg (assets/media/icons/mono): harter Tausch
             statt Morph-Animation, Balken 18x2px im 24er-Raster. -->
        <svg class="dah-header__burger-icon dah-header__burger-icon--menu" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z"/>
        </svg>
        <svg class="dah-header__burger-icon dah-header__burger-icon--close" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="m12 10.586 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/>
        </svg>
        <span class="dah-header__burger-label">Menü</span>
      </button>
      <div class="dah-header__metabar-nav">
        <div class="dah-account" [class.is-open]="accountOpen()">
          @if (signedIn()) {
            <!-- Icon rechts vom Label (Vendor rendert erst metanav-item-text, dann icon-wrapper; Prod-gemessen) -->
            <button type="button" class="dah-account__toggle" [attr.aria-expanded]="accountOpen()"
                    (click)="accountOpen.set(!accountOpen())">
              <span class="dah-account__label--short">Mein Konto</span>
              <span class="dah-account__label--long">{{userName()}}</span>
              <!-- Vendor-SVG user.svg (assets/media/icons/mono) -->
              <svg class="dah-account__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M4 22a8 8 0 0 1 16 0h-2a6 6 0 1 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"/>
              </svg>
            </button>
            @if (accountOpen()) {
              <div class="dah-account__menu">
                @for (link of tenant.content.account.menuLinks; track link.path) {
                  <a [href]="addBaseUrl(link.path)">{{link.label}}</a>
                }
                <a href="oauth2/logout" class="dah-account__logout">Abmelden</a>
              </div>
            }
          } @else {
            <a class="dah-account__toggle" [href]="tenant.content.loginUrl">
              <span class="dah-account__label--short">Mein Konto</span>
              <span class="dah-account__label--long">{{userName()}}</span>
              <svg class="dah-account__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M4 22a8 8 0 0 1 16 0h-2a6 6 0 1 0-12 0zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"/>
              </svg>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</header>
</div>

<div class="dah-offcanvas" [class.is-open]="navOpen()">
  <div class="dah-offcanvas__backdrop" (click)="setNavOpen(false)"></div>
  <nav class="dah-offcanvas__panel">
    @for (item of headerMenuItems; track item.href) {
      <a [href]="item.href">{{item.label}}</a>
    }
  </nav>
</div>
